import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
import { FooterComponent } from './components/footer/footer.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared/shared.module';
import { NavigationService } from './services/navigation.service';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    SharedModule,
    TranslateModule,
    MatIconModule,
  ],
  declarations: [
    PageNotFoundComponent,
    FooterComponent
  ],
  exports: [
    PageNotFoundComponent,
    FooterComponent
  ],
  providers: [
    NavigationService
  ]
})
export class CoreModule {
}
